export default __webpack_public_path__ + "media/images/icons_fc/tempsblanc-c9877aced66b9d2e1a56e0bfb2045199.png";